import script from "./TheResult.vue?vue&type=script&setup=true&lang=js"
export * from "./TheResult.vue?vue&type=script&setup=true&lang=js"

import "./TheResult.vue?vue&type=style&index=0&id=3715b450&lang=scss"

const __exports__ = script;

export default __exports__